import React, { useEffect, useMemo, useState } from "react";
import styles from "../topic.module.css";

import { api } from "../../api/api";
import { useModuleContext } from "../ModuleContext";
import RouteSteps from "./RouteSteps";

export default function RoutePanel() {
  const { language, showRoutes, showPoints, selectItem, selectedItem, focusMap } = useModuleContext();

  // routes (Themenrouten), configured in the DB (route/route_i18n)
  const [routes, setRoutes] = useState([]);
  // routes are fetched when the tab opens — don't flash the "empty" message meanwhile
  const [loaded, setLoaded] = useState(false);
  // only the selected route is drawn, so lines of different routes don't overlap
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    let cancelled = false;

    api
      .route(language)
      .then((data) => {
        if (cancelled) return;
        setRoutes(data);
        setLoaded(true);
      })
      .catch((err) => console.error("Route load failed:", err));

    return () => {
      cancelled = true;
    };
  }, [language]);

  const selected = routes.find((r) => r.id === selectedId) ?? null;

  // POIs along the selected route (route_poi, in sort_order) — used both as
  // map points and as steps in the side column, so a click on either one
  // opens the same detail and highlights the same step
  const steps = useMemo(
    () =>
      (selected?.pois ?? []).map((poi) => ({
        key: `routepoi-${selected.id}-${poi.poi_id}`,
        name: poi.name ?? "",
        info: poi.info ?? "",
        description: poi.info ?? "",
        imageUrl: poi.image_url ?? null,
        latitude: Number(poi.latitude),
        longitude: Number(poi.longitude),
      })),
    [selected],
  );

  useEffect(() => {
    showRoutes(selected ? [selected] : []);
    showPoints(steps);
  }, [selected, steps, showRoutes, showPoints]);

  const openStep = (step) => {
    selectItem(step);
    focusMap(step);
  };

  if (!loaded) return null;

  if (!routes.length) {
    return (
      <div className={styles["poi-page"]}>
        <div className={styles.message}>
          Noch keine Themenrouten hinterlegt.
        </div>
      </div>
    );
  }

  return (
    <div className={styles["poi-page"]}>
      <div className={styles.categories}>
        {routes.map((route) => (
          <button
            key={route.id}
            className={
              selectedId === route.id
                ? `${styles.categoryBtn} ${styles.categoryBtnActive}`
                : styles.categoryBtn
            }
            // click again to hide the route
            onClick={() => setSelectedId(selectedId === route.id ? null : route.id)}
          >
            {route.name}
          </button>
        ))}
      </div>

      {selected && steps.length > 0 && (
        <RouteSteps
          route={selected}
          steps={steps}
          activeKey={selectedItem?.key}
          onSelect={openStep}
        />
      )}
    </div>
  );
}
